import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full" }
const _hoisted_2 = { class: "text-sm font-normal flex flex-1" }

import { Icon, Toast } from "@toruslabs/vue-components";
import { useI18n } from "vue-i18n";

import { app, removeToast } from "@/modules/app";


export default /*#__PURE__*/_defineComponent({
  __name: 'Toast',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(app).toastMessages, (toast, idx) => {
    return (_openBlock(), _createBlock(_unref(Toast), {
      key: idx,
      open: toast.message !== '',
      class: "z-[60]",
      variant: toast.type,
      placement: "bottom-center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)(toast.message)), 1),
          _createVNode(_unref(Icon), {
            name: "x-solid-icon",
            class: "mt-[3px] cursor-pointer",
            onClick: ($event: any) => (_unref(removeToast)(toast))
          }, null, 8, ["onClick"])
        ])
      ]),
      _: 2
    }, 1032, ["open", "variant"]))
  }), 128))
}
}

})